import Vue from "vue"

import StarConditionLayout from '../components/StarConditionLayout/index'
import StarConditionCell from '../components/StarConditionLayout/StarConditionCell'
import TableHeadIcons from '@/components/TableHeadIcons'

Vue.component('StarConditionLayout', StarConditionLayout);
Vue.component('StarConditionCell', StarConditionCell);
Vue.component('TableHeadIcons', TableHeadIcons);
